import * as constants from "../../constants";

const defaultPageStatus = {
  actionsProcessing: 0,
  showSnackBar: false,
  successMessages: [],
  errorMessages: [],
};


export default function pageStatus(state = defaultPageStatus, action) {
  switch (action.type) {
    case constants.STATUS_CLOSE_SNACKBAR:
      // Keep the messages in place so the snackbar keeps its colour through the
      // exit animation (clearing them here makes snackbarFormat fall back to the
      // error/red class mid-close). They're reset when the next snackbar opens.
      return {
        ...state,
        showSnackBar: false,
      };
    case constants.STATUS_ERROR_MESSAGE:
      return {
        ...state,
        showSnackBar: true,
        // Opening a fresh snackbar (previously closed) drops any stale messages.
        successMessages: state.showSnackBar ? state.successMessages : [],
        errorMessages: [...(state.showSnackBar ? state.errorMessages : []), action.payload],
      };
    case constants.STATUS_SUCCESS_MESSAGE:
      return {
        ...state,
        showSnackBar: true,
        errorMessages: state.showSnackBar ? state.errorMessages : [],
        successMessages: [...(state.showSnackBar ? state.successMessages : []), action.payload],
      };
    case constants.STATUS_INCREMENT_PROCESSING:
      return {
        ...state,
        actionsProcessing: state.actionsProcessing + 1
      };
    case constants.STATUS_DECREMENT_PROCESSING:
      return {
        ...state,
        actionsProcessing: state.actionsProcessing - 1
      };
    default:
      return state;
  }
}